<div class="h-100 margin_page">
  <div class="row h-100">
    <div class="h-100 col-sm-12 col-lg-6 col-xl-5 offset-xl-1 lf-after-bg">
      <div class="custom-box_img lf-after-bg mb-3 pointer placeholder-glow">
        <div class="placeholder col-12" style="padding:100px"></div>
      </div>
      <h1 class="card-title placeholder-glow pb-3">
        <span class="placeholder col-12"></span>
      </h1>
      <div class="card-text placeholder-glow pb-4">
        <span class="placeholder col-12"></span>
      </div>
      <p class="card-text placeholder-glow">
        <span class="placeholder col-7"></span>
        <span class="placeholder col-4"></span>
        <span class="placeholder col-4"></span>
        <span class="placeholder col-6"></span>
        <span class="placeholder col-8 mb-2"></span>
        <span class="placeholder col-7"></span>
        <span class="placeholder col-4"></span>
        <span class="placeholder col-4"></span>
        <span class="placeholder col-6"></span>
        <span class="placeholder col-6"></span>
        <span class="placeholder col-8"></span>
        <span class="placeholder col-8 mb-3"></span>
        <span class="placeholder col-5"></span>
        <span class="placeholder col-10"></span>
        <span class="placeholder col-4"></span>
        <span class="placeholder col-3"></span>
        <span class="placeholder col-8 mb-2"></span>
        <span class="placeholder col-9"></span>
        <span class="placeholder col-8"></span>
        <span class="placeholder col-11"></span>
        <span class="placeholder col-6"></span>
        <span class="placeholder col-6"></span>
        <span class="placeholder col-8"></span>
        <span class="placeholder col-10 mb-2"></span>
      </p>
    </div>

    <div class="col-sm-12 col-lg-5 offset-lg-1 col-xl-4">
      <p class="card-text map-container h-100 placeholder-glow">
        <span class="placeholder h-100 col-12"></span>
      </p>
    </div>
  </div>
</div>
